import { render, staticRenderFns } from "./member-statistics.vue?vue&type=template&id=0f9c0a9a&scoped=true&"
import script from "./member-statistics.vue?vue&type=script&lang=js&"
export * from "./member-statistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9c0a9a",
  null
  
)

export default component.exports